import Main from "@/ts/base/Main";
import {Collapse} from "bootstrap";

export default class SiteFooter {

	protected main: Main;
	protected el: HTMLElement|null;
	protected contentWrapper!: HTMLElement;
	protected timeout!: number;
	protected nav!: HTMLUListElement|null;

    constructor() {
        this.main = Main.Instance;

        this.el = document.getElementById("SiteFooter");
        if (this.el) {
            this.contentWrapper = <HTMLElement>document.getElementById("SiteContent");
            this.timeout = 0;

            if (this.el.classList.contains("revealing")) {
                window.addEventListener("resize", this.onUpdate.bind(this));
                window.addEventListener(Main.IsLoadedClass, this.onUpdate.bind(this));
            }
        }
    }

    adjustSizes(): void {
		if (!(this.el instanceof HTMLElement)) {
			return;
		}

        if (this.el.style["position"] === "fixed") {
            let $adminbar = document.getElementById("wpadminbar");
            let footerHeight = Math.round(this.el.clientHeight - ($adminbar !== null ? $adminbar.clientHeight : 0));
            this.contentWrapper.style.marginBottom = `${footerHeight}px`;
        }
        else {
            this.contentWrapper.style.marginBottom = "";
        }
    }

	protected addToggleIconsToRootMenuItems(): void {
		if (!(this.el instanceof HTMLElement)) {
			return;
		}

		this.nav = this.el.querySelector("nav.navigation .menu");
		if (!(this.nav instanceof HTMLUListElement)) {
			return;
		}
		this.nav.classList.add("collapsible");
		this.nav.querySelectorAll("> li").forEach(
			(item) => {
				const submenu = item.querySelector("> .sub-menu");
				if (submenu !== null) {
					const toggle = document.createElement("li");
					const collapse = new Collapse(submenu, {
						toggle: false
					});
					toggle.classList.add("fas fa-plus");
					item.append(toggle);
					toggle.addEventListener("click", (e) => {
						if (submenu.classList.contains("show")) {
							collapse.hide();
						}
						else {
							collapse.show();
						}
					});
				}
			}
		);
	}

	protected onUpdate(e: Event) {
        window.clearTimeout(this.timeout);
        this.timeout = window.setTimeout(() => {
            this.adjustSizes();
        }, 50);
    }
}
